import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/lms/trainings-local")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
